export enum ServiceType {
    REST,
    ReportServer
}
